import React from 'react'
import {
  Segment,
  Item, ItemHeader, ItemContent, Header, Button, Icon
} from 'semantic-ui-react'
import {Link} from "react-router-dom"
import {getIcon, getStatus, getColor} from '../misc/Helpers'


function MyTrips({isTripsLoading, tripsMeAsDriver, tripsMeAsPass, cancelTrip, completeTrip}) {
  let tripsMeAsDriverList
  let tripsMeAsPassList

  const renderCancelButton = (trip) => {
    if (trip.status === 'PLANNED') {
      return (
        <Button primary floated='left' onClick={() => cancelTrip(trip.id)}>
          Отменить поездку
          <Icon name='right cancel'/>
        </Button>
      )
    }
  }
  const renderCompleteButton = (trip) => {
    if (trip.status === 'PLANNED') {
      return (
        <Button primary floated='left' onClick={() => completeTrip(trip.id)}>
          Завершить поездку
          <Icon name='right checkmark' />
        </Button>
      )
    }
  }

  const renderReviewLink = (trip) => {
    if (trip.status === 'COMPLETED') {
      return (
        <Link to={'/review/' + trip.id + '/' + trip.driver.id}>Оставить отзыв</Link>
      )
    }
  }

  const renderPassenger = (trip, num) => {
    if (trip.passengers && trip.passengers[num] && trip.status === 'COMPLETED') {
        return (
          <Item.Extra>
            Пассажир {trip.passengers[num].name} <Link to={'/review/' + trip.id + '/' + trip.passengers[num].id}>Оставить отзыв</Link>
          </Item.Extra>
        )
    }
  }

  if (tripsMeAsDriver.length > 0) {
    tripsMeAsDriverList = tripsMeAsDriver.map(trip => {
      return (
        <Item key={trip.id}>
          <Item.Content>
            <Item.Header>{trip.fromCity} - {trip.toCity}
            </Item.Header>
            <Item.Meta>{new Date(trip.tripTime).toLocaleString('ru',
              {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
              })}</Item.Meta>
            <Item.Description>
              Стоимость поездки {trip.cost} <br/>
              Едет {trip.currentPassengers} из {trip.maxPassengers} возможных <br/>
              Водитель {trip.driver.name} <br/>
            </Item.Description>
            {renderPassenger(trip, 0)}
            {renderPassenger(trip, 1)}
            {renderPassenger(trip, 2)}
            {renderPassenger(trip, 3)}
            <Item.Extra>
              Статус - <Icon color={getColor(trip.status)} name={getIcon(trip.status)} /> {getStatus(trip.status)}
            </Item.Extra>
            {renderCancelButton(trip)}
            {renderCompleteButton(trip)}
          </Item.Content>
        </Item>
      )
    })
  } else {
    tripsMeAsDriverList = <Item key='no-trips'>
      <ItemHeader>В настоящее время запланнированных поездок нет.</ItemHeader>
      <ItemContent><Link to="/createtrip">Создать Поездку</Link></ItemContent>
      </Item>
  }
  if (tripsMeAsPass.length > 0) {
    tripsMeAsPassList = tripsMeAsPass.map(trip => {
      return (
        <Item key={trip.id}>
          <Item.Content>
            <Item.Header>{trip.fromCity} - {trip.toCity}
            </Item.Header>
            <Item.Meta>{new Date(trip.tripTime).toLocaleString('ru',
              {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
              })}</Item.Meta>
            <Item.Description>
              Стоимость поездки {trip.cost} <br/>
              Едет {trip.currentPassengers} из {trip.maxPassengers} возможных <br/>
              Водитель {trip.driver.name} {renderReviewLink(trip)}
            </Item.Description>
            <Item.Extra>
              Статус поездки - <Icon color={getColor(trip.status)} name={getIcon(trip.status)} /> {getStatus(trip.status)} <br/>
              Статус заявки - <Icon color={getColor(trip.userTripStatus)} name={getIcon(trip.userTripStatus)} />{getStatus(trip.userTripStatus)}
            </Item.Extra>
          </Item.Content>
        </Item>
      )
    })
  } else {
    tripsMeAsPassList = <Item key='no-trips'>
      <ItemHeader>В настоящее время запланнированных поездок нет.</ItemHeader>
      <ItemContent><Link to="/trips">Искать Поездку</Link></ItemContent>
    </Item>
  }

  return (
    <Segment loading={isTripsLoading} color='blue'>
      <Header as='h1' textAlign='center'>Мои Поездки</Header>
      <Item.Group divided unstackable relaxed>
        <Item>
          <Item.Header as='h3' style={{color:'#2185d0'}}>
            Как Водитель
          </Item.Header>
        </Item>
        {tripsMeAsDriverList}
      </Item.Group>
      <Item.Group divided unstackable relaxed>
        <Item>
          <Item.Header as='h3' style={{color:'#2185d0'}}>
            Как Пассажир
          </Item.Header>
        </Item>
        {tripsMeAsPassList}
      </Item.Group>
    </Segment>
  )
}

export default MyTrips
